import { render, staticRenderFns } from "./CreateStructure.vue?vue&type=template&id=9e8887f2&"
import script from "./CreateStructure.vue?vue&type=script&lang=js&"
export * from "./CreateStructure.vue?vue&type=script&lang=js&"
import style0 from "./CreateStructure.vue?vue&type=style&index=0&id=9e8887f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports